export default __webpack_public_path__ + "static/media/chocolatedonuts-image.e4f943fe.png";